import { Injectable } from '@angular/core';
import { Project } from '@src/app/models/project';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../../orgprojectadd/model/customer';
import { Customerdeal } from '@src/app/models/customerdeal';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

@Injectable({
  providedIn: 'root'
})
export class OrgprojecteditService {

  serviceUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/';

  customerUrl:string = environment.apiUrl+'/organization/';
  constructor(private http:HttpClient) { }
  
  getProject(project:Project){
    return this.http.get<Project>(this.serviceUrl+project.projectId,httpOptions)
  }

  updateProject(project:Project){
    return this.http.patch<string>(this.serviceUrl+project.projectId, project, {
      ...httpOptions,
      responseType: 'text' as 'json' // Backend returns plain string UUID, not JSON
    })
  }

  deleteProject(project:Project){
    return this.http.delete<any>(this.serviceUrl+project.projectId,httpOptions)
  }
  // getCustomers(){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   }
  //   ///organization/{organizationId}/customer/list/pit/{pitdate}
  //   return this.http.get<Customer[]>(this.customerUrl+SessionHelper.getChoosenOrg()+"/customer/list/pit/"+ new Date().toISOString(),httpOptions);
  // }
      //get deals for customer
      getDeals(customerId,pit){
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        }
        //GET	    /organization/{organizationId}/customer/{customerId}/deal/list/pit/{pitdate}
        return this.http.get<Customerdeal[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/deal/list/pit/'+pit,httpOptions);
     
      }
}
